/**
* @Author: zachalam
* @Date:   2017-01-25T11:21:47-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-25T11:21:47-08:00
*/



export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // Ignore for now
  }
};



// WEBPACK FOOTER //
// ./src/localStorage.js